export default __webpack_public_path__ + "static/media/a011-PPII-6.0ccac50a.svg";